import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Heading,
} from "@chakra-ui/react";
import "./Accordian.scss";

export const Accordian = ({ children1, children2, children3 }) => {
  return (
    <Accordion defaultIndex={[0]} allowMultiple>
      <AccordionItem className="accordian">
        <Heading
          as="h2"
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <AccordionButton
            className="title-container"
            style={{ width: "100%" }}
          >
            {children1}
            <AccordionIcon />
          </AccordionButton>
          {children2 && (
            <Box
              style={{
                position: "absolute",
                right: "50px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {children2}
            </Box>
          )}
        </Heading>
        <AccordionPanel>{children3}</AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};
